import cities from './cities.json'
import cities2025 from './cities2025.json'
import cities2026 from './cities2026.json'

export default { cities, cities2025, cities2026 }
